/* eslint-disable no-magic-numbers */

import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import wordScaleSnapInLeftGif from '../../../assets/images/transitions/wordScaleSnapInLeft.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_WORD_SCALE_SNAP_OUT_LEFT = 'wordScaleSnapOutLeft';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const wordScaleSnapOutLeftPresetDetails = {
  // The name of the preset.
  name: PRESET_WORD_SCALE_SNAP_OUT_LEFT,

  // A human friendly name for the preset.
  humanName: 'Word Scale & Snap Out - Left',

  // A preview of the transition.
  gif: wordScaleSnapInLeftGif,

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'word.scaleY': {
      time: {
        end: 'end.0',
        start: 'end.-1500'
      },
      easing: EASINGS.easeOutExpo,
      values: [
        1,
        0
      ],
      stagger: 50,
      staggerDuration: false,
      immediateRender: false
    },
    'word.translateX': {
      time: {
        end: 'end.0',
        start: 'end.-2000'
      },
      easing: EASINGS.easeInOutExpo,
      values: [
        0,
        -400
      ],
      stagger: 50,
      staggerDuration: false,
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_WORD_SCALE_SNAP_OUT_LEFT,
    options: {},
  },
};

wordScaleSnapOutLeftPresetDetails.template.options = lodash.cloneDeep(wordScaleSnapOutLeftPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_WORD_SCALE_SNAP_OUT_LEFT;

// This defines the value of the presets object.
export default wordScaleSnapOutLeftPresetDetails;

